import React from 'react';

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a chunk loading error
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      return { hasError: true, error };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Chunk loading error:', error, errorInfo);
    
    // If it's a chunk loading error, reload the page
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      console.log('Chunk loading failed, reloading page...');
      // Give user a moment to see any error message, then reload
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }

  render() {
    if (this.state.hasError) {
      // Check if it's specifically a chunk loading error
      if (this.state.error?.name === 'ChunkLoadError' || 
          this.state.error?.message?.includes('Loading chunk')) {
        return (
          <div style={{ 
            padding: '20px', 
            textAlign: 'center', 
            fontFamily: 'Arial, sans-serif' 
          }}>
            <h2>Laster ny versjon...</h2>
            <p>Siden oppdateres automatisk om et øyeblikk.</p>
            <div style={{ 
              margin: '20px auto', 
              width: '50px', 
              height: '50px', 
              border: '3px solid #f3f3f3', 
              borderTop: '3px solid #06538b', 
              borderRadius: '50%', 
              animation: 'spin 1s linear infinite' 
            }}></div>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        );
      }

      // Generic error fallback
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          fontFamily: 'Arial, sans-serif' 
        }}>
          <h2>Noe gikk galt</h2>
          <p>Prøv å oppdatere siden.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#06538b',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Oppdater siden
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;